import { Button, Col, Form, Row, message, Select, DatePicker } from "antd";
import React, { useState } from "react";
import moment from "moment";
import { reportService } from "_services";

function AvailableStockSearch(props) {
  const [form] = Form.useForm();
  let dateFilter = false;
  let fromDate = null;
  let toDate = null;

  if (props.addresses != null && props.addresses.length === 1) {
    form.setFieldValue("storeLocationId", props.addresses[0].id);
  }

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "";
    searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
    if (values.requestDateRange) {
      searchParams += `fromDate=${encodeURIComponent(
        moment(values.requestDateRange[0]).startOf("day").format("YYYY-MM-DD")
      )}&toDate=${moment(values.requestDateRange[1])
        .startOf("day")
        .format("YYYY-MM-DD")}`;
      fromDate = moment(values.requestDateRange[0])
        .startOf("day")
        .format("YYYY-MM-DD");
      toDate = moment(values.requestDateRange[1])
        .startOf("day")
        .format("YYYY-MM-DD");
      dateFilter = true;
    } else {
      searchParams += `fromDate=${encodeURIComponent(
        moment("2021-01-01").format("YYYY-MM-DD")
      )}&toDate=${moment().format("YYYY-MM-DD")}`;
      dateFilter = false;
    }
    if (values.storeLocationId) {
      searchParams += `&storeLocations=${values.storeLocationId}`;
    } else {
      searchParams += `&storeLocations=${props.addresses
        .map((item) => item.id)
        .join()}`;
    }
    if (values.materialType) {
      searchParams += `&materialType=${values.materialType}`;
    }
    if (values.stockClassId) {
      searchParams += `&stockClassId=${values.stockClassId}`;
    }

    reportService
      .getAvailableStocksByView(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content,
          fromDate,
          toDate,
          dateFilter,
          searchParams
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });

    reportService
      .getAvailableStockTotals(searchParams)
      .then((data) => {
        if (data.content) {
          props.onSearchResultTotal(data.content);
        } else {
          props.onSearchResultTotal(null);
        }
      })
      .catch((error) => {
        props.onSearchResultTotal(null);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={4}>
          <Form.Item name="requestDateRange" label="Receive Date">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="storeLocationId" label="Store Location">
            <Select
              placeholder="Please select"
              allowClear
              loading={props.loadingStoreAddress}
            >
              {props.addresses.length > 0 &&
                props.addresses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.address}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="materialType" label="Material">
            <Select
              showSearch
              allowClear
              optionFilterProp="children"
              placeholder="Material Type"
              loading={props.loadingStockTypes}
            >
              {props.stockTypes.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="stockClassId" label="Stock Category">
            <Select
              placeholder="Please select"
              allowClear
              loading={props.loadingStockClassification}
            >
              {props.stockClasses.length > 0 &&
                props.stockClasses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}> </Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default AvailableStockSearch;
